import React, { useState } from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./Layout/Navbar";
import SoftNavbar from "./SoftwareLayout/Navbar";
import Sidebar from "./SoftwareLayout/Sidebar";
import Footer from "./Layout/Footer";
import Home from "./Pages/Home";
import About from "./Pages/About";
import Contact from "./Pages/Contact";
import Blog from "./Pages/Blog";
import OurServices from "./Pages/OurServices";
import Ourfleet from "./Pages/Ourfleet";
import Privacy from "./Pages/Privacy";
import TermCondition from "./Pages/TermCondition";
import Register from "./Pages/Register";
import Logins from "./Pages/Logins";
import Car_booking from "./Pages/Car_booking";

import Dashboard from "./SoftwarePages/Dashboard/Dashboard";
import ChangePassword from "./SoftwarePages/ChangePassword/ChangePassword";
import AddCar from "./SoftwarePages/Cars/AddCar";
import CarList from "./SoftwarePages/Cars/CarList";
import ContactList from "./SoftwarePages/ContactList/ContactList";
import Booking from "./SoftwarePages/Booking/Booking";
import Users from "./SoftwarePages/Users/Users";
import OfferCar from "./SoftwarePages/Offers/OfferCar";
import OfferCarList from "./SoftwarePages/Offers/OfferCarList";
import { Protected } from "./Protected/Protected";

function Layout() {
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const location = useLocation();
  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  // Check if current route is part of the software section
  const isSoftwarePage = location.pathname.startsWith("/software");
  // const isLoginPage = location.pathname === "/login";

  return (
    <div className="App">
      {/* Conditional Navbar */}
      {!isSoftwarePage && <Navbar />}
      {isSoftwarePage && <SoftNavbar toggleSidebar={toggleSidebar} />}

      <div className="app-container">
        {/* Conditional Sidebar */}
        {isSoftwarePage && <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />}
        <div className="main-content">
          <Routes>
            {/* Public Website Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/ourServices" element={<OurServices />} />
            <Route path="/ourFleet" element={<Ourfleet />} />
            <Route path="/policy" element={<Privacy />} />
            <Route path="/termcondition" element={<TermCondition />} />
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Logins />} />
            {/* <Route path="/car_booking/:id" element={<Car_booking />} /> */}
             <Route path="/car_booking/:id" element={<Protected Component={Car_booking} />} />
             

            {/* Software Section Routes */}
            {/* <Route path="/software/dashboard" element={<Protected Component={Dashboard} />} /> */}
            <Route path="/software/dashboard" element={<Dashboard />} />
            <Route path="/software/user" element={<Protected Component={Users} />} />
            <Route path="/software/addCar" element={<Protected Component={AddCar} />} />
            <Route path="/software/carList" element={<Protected Component={CarList} />} />
            <Route path="/software/offerCar" element={<Protected Component={OfferCar} />} />
            <Route path="/software/offercarList" element={<Protected Component={OfferCarList} />} />
            <Route path="/software/contactlist" element={<Protected Component={ContactList} />} />
            <Route path="/software/booking" element={<Protected Component={Booking} />} />
            <Route path="/software/changepassword" element={<Protected Component={ChangePassword} />} />

          </Routes>
      {!isSoftwarePage  &&<Footer/> }

        </div>
        
      </div>
      
    </div>
  );
}

function App() {
  return (
    <Router>
      <Layout />
    </Router>
  );
}

export default App;
